export function formatCurrency(amount: number, currency: string = 'USD'): string {
  if (Number.isNaN(amount) || amount === null || amount === undefined) {
    return '—';
  }

  try {
    return new Intl.NumberFormat('en', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    // Fallback in case of invalid currency code
    return `${amount.toFixed(2)} ${currency}`;
  }
}
